import i18n from '@/services/i18n'

export const buttonText = {
  'top_level_domain': i18n.t("childRequests.addToWhitelist")
}

export const titleText = {
  'top_level_domain': i18n.t("childRequests.hasRequestedAccessTo")
}